// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"7560":"8bb59db6d769c5865c25","8618":"d30d39583cd1936d2676"}[chunkId] + "";
};